import { render, staticRenderFns } from "./ListBlackListUserPage.vue?vue&type=template&id=1539c6c8"
import script from "./ListBlackListUserPage.vue?vue&type=script&lang=js"
export * from "./ListBlackListUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports